
export const apiDomain='https://apil.auto-turki.com' //prod
export const filePath = "https://apil.auto-turki.com"; //prod


//export const apiDomain='http://127.0.0.1:8000' //Local
//export const filePath = "http://127.0.0.1:8000"; //for local







